import { Page } from "../page";

export class AllocationConstraintRequest extends Page{
    storer: string | null;
    activeFlag: string | null;
    brand: string | null;
    consigneeKey: string[] | null;
    checkType: string[] | null;
    sku: string[] | null;
    language: string | null;


    constructor(){
        super();
        this.activeFlag = null;
        this.brand = null;
        this.consigneeKey = [];
        this.checkType = [];
        this.storer = null;
        this.sku = [];
        this.language = null;
    }
}
